var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _circle, _circle2, _rect18, _rect19, _rect20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.55078,
    y: 1.35449,
    width: 3,
    height: 20.1981,
    rx: 1.5,
    transform: "rotate(-12.2792 1.55078 1.35449)",
    fill: "#F95780"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6797,
    y: 7.80176,
    width: 3,
    height: 13.0115,
    rx: 1.5,
    transform: "rotate(13.2874 25.6797 7.80176)",
    fill: "#F95780"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6875,
    y: 21,
    width: 3,
    height: 20.2212,
    rx: 1.5,
    transform: "rotate(-89.9275 5.6875 21)",
    fill: "#F95780"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6875,
    y: 11,
    width: 3,
    height: 23.462,
    rx: 1.5,
    transform: "rotate(-89.9275 4.6875 11)",
    fill: "#F95780"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 10.6875 20)",
    fill: "#F95780"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 8.6875 20)",
    fill: "#F95780"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6875,
    y: 13,
    width: 1,
    height: 20,
    rx: 0.5,
    transform: "rotate(-90 5.6875 13)",
    fill: "#F95780"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6875,
    y: 15,
    width: 1,
    height: 20,
    rx: 0.5,
    transform: "rotate(-90 5.6875 15)",
    fill: "#F95780"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6875,
    y: 17,
    width: 1,
    height: 20,
    rx: 0.5,
    transform: "rotate(-90 5.6875 17)",
    fill: "#F95780"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 12.6875 20)",
    fill: "#F95780"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 14.6875 20)",
    fill: "#F95780"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 16.6875 20)",
    fill: "#F95780"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 18.6875 20)",
    fill: "#F95780"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 20.6875 20)",
    fill: "#F95780"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 22.6875 20)",
    fill: "#F95780"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 24.6875 20)",
    fill: "#F95780"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 2.45215,
    width: 1.44856,
    height: 3.80905,
    rx: 0.724279,
    transform: "rotate(-89.9275 0 2.45215)",
    fill: "#F95780"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1875,
    cy: 23.5,
    r: 2.5,
    fill: "#F95780"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1875,
    cy: 23.5,
    r: 2.5,
    fill: "#F95780"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F95780"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    width: 12,
    height: 12,
    rx: 6,
    stroke: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 5,
    width: 8,
    height: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCart);
export default __webpack_public_path__ + "static/media/RedCart.3ec15f3ea665664f62ff0733be5e7b8e.svg";
export { ForwardRef as ReactComponent };